// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as Random from "bs-platform/lib/es6/random.js";
import * as Caml_array from "bs-platform/lib/es6/caml_array.js";

function makeDots(numDots, element) {
  Random.self_init(undefined);
  var dotColors = [
    "rgba(29, 14, 190, 0.5)",
    "rgba(162, 165, 252, 0.5)",
    "rgba(98, 125, 152, 0.5)"
  ];
  element.style;
  var createDot = function (param) {
    var top = String(Random.$$int(110) - 10 | 0) + "%";
    var left = String(Random.$$int(110) - 10 | 0) + "%";
    var size = String(Random.$$int(9) + 10 | 0) + "px";
    var x = String(Random.$$int(71) + 30 | 0) + "px";
    var y = String(Random.$$int(71) + 30 | 0) + "px";
    var transformOrigin = x + (" " + y);
    var animationDuration = String(Random.$$int(15) + 10 | 0) + "s";
    var animationDelay = String(Math.imul(Random.$$int(8), -1)) + "s";
    var animation = "orbit " + (animationDuration + (" linear " + (animationDelay + " infinite")));
    var color = Caml_array.caml_array_get(dotColors, Random.$$int(dotColors.length));
    var dot = document.createElement("div");
    dot.className = "dot";
    var style = dot.style;
    style.setProperty("top", top, "");
    style.setProperty("left", left, "");
    style.setProperty("width", size, "");
    style.setProperty("height", size, "");
    style.setProperty("transform-origin", transformOrigin, "");
    style.setProperty("animation", animation, "");
    style.setProperty("background-color", color, "");
    element.appendChild(dot);
    
  };
  for(var _for = 0; _for <= numDots; ++_for){
    setTimeout(createDot, 0);
  }
  
}

export {
  makeDots ,
  
}
/* No side effect */
